import cartOptions from '../../coto_scripts/cart/cart-slide';

export const delDiaPdp = {
  methods: {
    getChoiceProducts() {
      axios
        .get(
          `https://production-access-api.cotopaxi.com/choice/getChoiceItemsGridByProductId/${this.productId}`
        )
        .then((response) => {
          if (
            response.data.hasOwnProperty('Status') &&
            response.data.Status.includes('Error')
          ) {
            this.error = true;
          }

          //set surprise me product object
          this.ddProduct = {
            id: response.data.id,
            title: response.data.title,
            whyYoullLoveIt: response.data.whyYoullLoveIt,
            headerImageDesktop: response.data.headerImageDesktop,
            headerImageMobile: response.data.headerImageMobile,
            url: response.data.url,
            price: response.data.price,
            inventoryCount: response.data.inventoryCount,
            supriseMeVariantId: response.data.supriseMeVariantId,
            backorderMessage: response.data.backorderMessage,
            images: response.data.images,
            imageMaps: response.data.imageMaps,
          };

          if (response.data.choiceItems.length > 0) {
            //set choice products array
            this.choiceProducts = response.data.choiceItems;
            //this.selectedVariant = response.data.choiceItems[0];
            this.selectVariant(response.data.choiceItems[0]);
          } else {
            //for non-choice dd products
            this.selectedVariant = this.ddProduct;
            this.selectedVariantID = this.ddProduct.supriseMeVariantId;
            this.updateUrl();
            //this.selectVariant(this.ddProduct);
          }

          //default to suprise if less than 5 choice items
          if (this.choiceProducts.length < 5) {
            this.isSurprise = true;
          }

          if (response.data.inventoryCount <= 0) {
            if (response.data.backorderMessage) {
              this.backorder = true;
            } else {
              this.soldout = true;
            }
          }

          this.loading = false;
        })
        .catch((error) => {
          this.error = true;
          this.loading = false;
          window.location.replace(window.location.href + '?view=default');
        });
    },

    selectVariant(product) {
      //this.minimized = false;
      this.selectedVariant = product;
      this.selectedVariantID = product.variantId;

      this.updateUrl();
    },

    //---- ADD TO CART
    addToCart() {
      // add the selected variant and quantity
      //no quantity on this template, so we will always add 1.
      if (this.isSurprise) {
        vueSideCart.addItem(this.ddProduct.supriseMeVariantId, 1, {
          _saleStatus: 'Current',
        });
      } else {
        vueSideCart.addItem(this.selectedVariant.variantId, 1, {
          _imgUrl: this.selectedVariant.images[0].src,
          _saleStatus: 'Current',
        });
      }

      //open the side cart after a brief delay.
      // setTimeout(function(){
      // 	cartOptions.openCart();
      // }, 500);
    },

    //activate the accordion drawer
    activateAccordion(drawer) {
      // if this drawer is already open, close it
      if (this.activeDrawer === drawer) {
        this.activeDrawer = null;
      } else {
        // otherwise, open the drawer
        this.activeDrawer = drawer;
      }
    },
  },
};
